import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';

/* import icons here */
import {
  faUserFriends,
  faBed,
  faBath,
  faHome
} from '@fortawesome/free-solid-svg-icons';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FontAwesomeModule
  ],
  exports: [FontAwesomeModule]
})
export class NGFontAwesomeModule {
  /* register icons here */
  constructor() {
    library.add(faBath);
    library.add(faBed);
    library.add(faHome);
    library.add(faUserFriends);
  }
 }
